import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'welcome',
		pathMatch: 'full'
	},
	{
		path: 'welcome',
		loadChildren: () => import('./modules/welcome/welcome.module')// eslint-disable-line
			.then(module => module.WelcomeModule)
	},
	{
		path: 'search',
		loadChildren: () => import('./modules/search/search.module') // eslint-disable-line
			.then(module => module.SearchModule)
	},
	{
		path: 'static-page',
		loadChildren: () => import('./modules/static-page/static-page.module') // eslint-disable-line
			.then(module => module.StaticPageModule)
	},
	{
		path: 'detail',
		loadChildren: () => import('./modules/detail/detail.module') // eslint-disable-line
			.then(module => module.DetailModule)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
